export function init(rootEl = document) {
  rootEl.querySelectorAll('input[type="password"]').forEach((input) => {
    const wrapper = document.createElement('div');
    wrapper.className = 'password-input-wrapper';
    input.before(wrapper);
    wrapper.append(input);

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'password-visibility-toggle';
    toggle.dataset.cy = 'password-visibility-toggle';
    toggle.setAttribute('aria-label', 'Show password');
    toggle.setAttribute('aria-pressed', 'false');
    toggle.innerHTML = '<i class="fas fa-eye" aria-hidden="true"></i>';
    wrapper.append(toggle);

    toggle.addEventListener('click', () => {
      const visible = input.type === 'password';
      input.type = visible ? 'text' : 'password';
      toggle.setAttribute('aria-label', visible ? 'Hide password' : 'Show password');
      toggle.setAttribute('aria-pressed', String(visible));
      toggle.querySelector('i').classList.toggle('fa-eye', !visible);
      toggle.querySelector('i').classList.toggle('fa-eye-slash', visible);
    });
  });
}
